import { render, staticRenderFns } from "./BoStaticSeo.vue?vue&type=template&id=2f8703ba&"
import script from "./BoStaticSeo.vue?vue&type=script&lang=js&"
export * from "./BoStaticSeo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports